// extracted by mini-css-extract-plugin
module.exports = {"open":"SlideUpFooter-open-3S3IJ","closed":"SlideUpFooter-closed-2fMCe"};